import Swiper from 'swiper';
import { md } from '../common';

export function initCartridgesShowcase() {
  new Swiper('.js-cartidges-showcase__swiper', {
    direction: 'horizontal',
    slidesPerView: 'auto',
    breakpoints: {
      [md]: {
        enabled: false,
      },
    },
  });
}
